exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".leaderboard.nominate h1{color:var(--primary)!important}.nominate__click:disabled{pointer-events:none}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/DraftsList.vue"],"names":[],"mappings":"AACA,yBACE,8BAAiC,CAClC,AACD,0BACE,mBAAqB,CACtB","file":"DraftsList.vue","sourcesContent":["\n.leaderboard.nominate h1 {\n  color: var(--primary) !important;\n}\n.nominate__click:disabled {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d5f93f2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/Nominations/DraftsList.vue
// module id = 1353
// module chunks = 11